<template>
    <div>
        <v-app-bar
            height="84"
            elevation="0"
            color="transparent"
            style="position: fixed; z-index: 1"
        >
            <v-toolbar-title>
                <v-img
                    :src="require('@/assets/schooney_logo.png')"
                    class="my-3"
                    contain
                />
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon>
                <a
                    @click="changeLocale('th')"
                    class="prompt-16"
                    style="font-weight: 400; color: #37323c"
                    >ไทย</a
                >
            </v-btn>
            <div style="height: 20px">
                <v-divider
                    vertical
                    inset
                    color="black"
                    style="border: 0.5px solid #37323c"
                ></v-divider>
            </div>
            <v-btn icon>
                <a
                    @click="changeLocale('en')"
                    class="prompt-16"
                    style="font-weight: 400; color: #37323c"
                    >EN</a
                >
            </v-btn>
        </v-app-bar>
    </div>
</template>
  
<script>
import i18n from "@/i18n";
export default {
    name: "NavbarTransparentBlack",
    methods: {
        changeLocale(locale) {
            localStorage.setItem("language", locale);
            i18n.locale = locale;
        },
    },
};
</script>
  